module.exports = __webpack_public_path__ + "static/media/icon-log.475a4111.svg";